module.exports = __webpack_public_path__ + "media/images/products/cards/programa_tap-a22b327875ebc2d9ff9b0dd060f28e1a.png";